module.exports = __webpack_public_path__ + "img/13-1.d4deeb00.png";